import React, { useContext, useState } from 'react';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Full } from '../Edu/Full';
import { PersonaMinimal } from '../PersonaMinimal';
import { isOpenPentaMember, withPentaMemberOrder } from '../utilsPenta';
import { PentaMemberActions } from './PentaMemberActions';
import { PentaModeSwitch } from './PentaModeSwitch';

export function PentaCompare({
  penta,
  callback = () => void (0),
  compare = true,
  setCompare,
  openMemberPicker = () => void (0),
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext) };
  const [dragMemberIndex, setDragMemberIndex] = useState(null);
  const [dropMemberIndex, setDropMemberIndex] = useState(null);

  const realMembers = (penta.members || []).filter((one) => !isOpenPentaMember(one));
  const showAddSlot = Boolean(
    (penta.token && realMembers.length === 1)
    || (!penta.token && (penta.members || []).some(isOpenPentaMember))
  );
  const compareColumnCount = realMembers.length + (showAddSlot ? 1 : 0);
  const compareColumnWidth = `${(100 / compareColumnCount)}%`;
  const canReorderMembers = Boolean(context.me && penta.token && realMembers.length > 1);
  const showMemberActions = Boolean(context.me && penta.my !== false && (penta.token || penta.unsaved));

  const reorderMembers = (fromIndex, toIndex) => {
    if (fromIndex == null || toIndex == null || fromIndex === toIndex) return;

    const members = [...penta.members];
    const [moved] = members.splice(fromIndex, 1);
    members.splice(toIndex, 0, moved);
    const reordered = withPentaMemberOrder(penta, members);
    callback(reordered);

    if (penta.my !== false && penta.token) {
      context.x.updatePenta({
        token: reordered.token,
        description: reordered.description,
        members: reordered.members,
      });
    }
  };

  const openPentaPeoplePanel = () => {
    if (!penta.token) {
      openMemberPicker();
      return;
    }
    context.setState.choosePenta(penta.token);
  };

  return (
    <div className="x_edu_penta_compare">
      <div className="x_edu_penta_mode_switch">
      <PentaModeSwitch
        compare={compare}
        setCompare={setCompare}
        memberCount={penta.members.length}
      />
      </div>
      <div className="x_edu_content">
        <div className="x_edu_penta_persons">
        {realMembers.map((one, index) => (
          <div
            key={`penta_body_${penta.token}_${one.avatar.token}`}
            className="x_edu_penta_oneperson"
            style={{
              flexBasis: compareColumnWidth,
              opacity: dragMemberIndex === index ? 0.55 : 1,
              outline: dropMemberIndex === index && dragMemberIndex !== index
                ? '2px dashed var(--color-1, #888)'
                : undefined,
              outlineOffset: '4px',
            }}
            onDragOver={(e) => {
              if (!canReorderMembers) return;
              e.preventDefault();
              e.dataTransfer.dropEffect = 'move';
              setDropMemberIndex(index);
            }}
            onDragLeave={() => {
              setDropMemberIndex((prev) => (prev === index ? null : prev));
            }}
            onDrop={(e) => {
              if (!canReorderMembers) return;
              e.preventDefault();
              const fromIndex = dragMemberIndex ?? Number(
                e.dataTransfer.getData('application/x-penta-member-index')
              );
              reorderMembers(fromIndex, index);
              setDragMemberIndex(null);
              setDropMemberIndex(null);
            }}
          >
            <div
              className="x_penta_member_top"
              style={{
                marginTop: '1em',
                marginBottom: '1em',
              }}
            >
              <PersonaMinimal
                onClick={() => 1}
                avatar={one.avatar}
                type="calc"
                mode="hd"
              />
            </div>

            <Full
              noBodyView={true}
              noAstro={true}
              noJyotish={true}
              addClassName="penta"
              numbers={false}
              aura={true}
              user={one.user}
              hoverable={true}
              avatar={one.avatar}
              noSettings={true}
              noSearch={true}
              noHints={true}
              noDob={true}
              penta={penta}
              addControls={
                showMemberActions
                && (
                  <PentaMemberActions
                    penta={penta}
                    avatar={one.avatar}
                    callback={callback}
                  />
                )
              }
            />
          </div>
        ))}

        {showAddSlot && (
          <div
            key={`penta_body_${penta.token}_add`}
            className="x_edu_penta_oneperson"
            style={{ flexBasis: compareColumnWidth }}
          >
            <div className="x_edu_penta_empty_container_inner">
              <div className="x_edu_penta_empty_container">
                <div className="x_penta_member_top" />
                <div className="x_edu_ava1">
                  <div className="x_edu_ava1_body">
                    <div
                      className="x_penta_slot x_penta_slot--main x_penta_slot--empty"
                      onClick={openPentaPeoplePanel}
                    >
                      <div className="t_icon t_icon--40">
                        <div>add</div>
                      </div>
                    </div>
                  </div>
                  <div className="x_penta_typeprofile" />
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
